import { render } from "./c-menu.vue?vue&type=template&id=39452c61"
import script from "./c-menu.vue?vue&type=script&lang=js"
export * from "./c-menu.vue?vue&type=script&lang=js"

import "./c-menu.vue?vue&type=style&index=0&id=39452c61&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__